<script>
import axios from 'axios';
import utilsService from '@/api/utilsService';

const TIPO = 'CONDICION';
const apiUrl = `${process.env.VUE_APP_API_URL}/api/diccionarios`;
const token = utilsService.getToken();

const condicionService = {
  async getAll() {
    try {
      const response = await axios.get(`${apiUrl}?tipo=${TIPO}`, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      });
      return response.data;
    } catch (error) {
      throw new Error('Error fetching data: ' + error.message);
    }
  },

  async get(id) {
    try {
      const lista = await this.getAll();
      const items = lista || [];
      const encontrado = items.find(item => String(item.id) === String(id));
      return encontrado || {};
    } catch (error) {
      window.location.href = '/error';
    }
  },

  async create(formRaw) {
    try {
      const form = {
        tipo: TIPO,
        nombre: formRaw.nombre,
        nombreIngles: formRaw.nombreIngles,
        codigo: formRaw.codigo,
        observacion: formRaw.observacion,
      };

      const response = await axios.post(apiUrl, form, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      });
      return response;
    } catch (error) {
      // Si viene de Axios, re-lanzar tal cual para conservar response.status y response.data
      if (error && error.response) {
        throw error;
      }
      throw {
        response: {
          status: 0,
          data: (error && error.message) ? error.message : 'Error en la solicitud.',
        },
      };
    }
  },

  async update(formRaw, id) {
    try {
      const form = {
        nombre: formRaw.nombre,
        nombreIngles: formRaw.nombreIngles,
        codigo: formRaw.codigo,
        observacion: formRaw.observacion,
      };

      const response = await axios.put(`${apiUrl}/${TIPO}/${id}`, form, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      });
      return response.status;
    } catch (error) {
      if (error.response && error.response.data) {
        throw new Error(error.response.data || 'Error al actualizar la condición.');
      } else {
        throw new Error(error.message || 'Error en la solicitud.');
      }
    }
  },

  async deleteBy(id) {
    try {
      const response = await axios.delete(`${apiUrl}/${TIPO}/${id}`, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      });
      return response.status;
    } catch (error) {
      throw new Error('Error fetching data: ' + error.message);
    }
  },
};

export default condicionService;
</script>
